import { useCallback } from 'react';
import { useFormContext } from 'react-hook-form';

import DiscountCalendar, { IPropsDiscountCalendar } from '../../discount/components/DiscountCalendar';
import { NOTIFICATION_FIELD_KEYS } from '../validates/notificationSchema';

export interface IPropsCalendarItem {
  title: string;
  start: Date;
}

export interface IPropsNotificationCalendarPresenter {
  events: IPropsCalendarItem[];
  calenderHeight?: number | string;
  calenderWidth?: number | string;
}

function NotificationCalendarPresenter(props: IPropsNotificationCalendarPresenter) {
  const { events, calenderHeight, calenderWidth } = props;

  const { watch } = useFormContext();
  const [sendAt, title] = watch([NOTIFICATION_FIELD_KEYS.SEND_AT, NOTIFICATION_FIELD_KEYS.TITLE]);
  const getCalendarEvents = useCallback((): IPropsDiscountCalendar['events'] => {
    let eventList: IPropsDiscountCalendar['events'] = [];
    if (events) {
      eventList = events.map((event) => {
        return {
          title: event.title,
          start: event.start,
          end: event.start,
        };
      });
    }
    if (title && sendAt) {
      eventList.push({
        title,
        start: sendAt,
        end: sendAt,
      });
    }

    return eventList;
  }, [events, title, sendAt]);

  return <DiscountCalendar events={getCalendarEvents()} height={calenderHeight} width={calenderWidth} />;
}

export default NotificationCalendarPresenter;
